import PropTypes from "prop-types";
import React from "react";
import Dropzone from "react-dropzone";

class Media extends React.PureComponent {

    constructor() {
        super();
        this.objectUrls = [];
    }

    handleDrop(accepted, rejected) {
        rejected.forEach(f =>
            alert(`${f.name} was rejected...`),
        );
        if (accepted.length === 0) {
            this.props.onChange(null);
            return;
        }
        accepted.forEach(f => {
            if (f.type.startsWith("image/")) {
                f.preview = URL.createObjectURL(f);
                this.objectUrls.push(f.preview);
            }
            this.props.onChange(f);
        });
    }

    componentWillUnmount() {
        this.objectUrls.forEach(u => URL.revokeObjectURL(u));
        this.objectUrls = [];
    }

    render() {
        const {
            value: file,
            onChange,
        } = this.props;
        return <Dropzone
            accept="image/*"
            onDrop={(a, r) => this.handleDrop(a, r)}
            disablePreview={true}
            multiple={false}
            className="Dropzone"
            acceptClassName="Dropzone-accept"
            rejectClassName="Dropzone-reject"
        >
            {file
                ? <div>
                    {file.preview
                        ? <img src={file.preview}
                               alt={file.name}
                               style={{
                                   maxWidth: "100px",
                                   maxHeight: "100px",
                               }} />
                        : file.name
                    }
                    <button onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        return onChange(null);
                    }}>
                        remove
                    </button>
                </div>
                : "Drop file or click to shoot/select."
            }
        </Dropzone>;
    }

}

Media.propTypes = {
    value: PropTypes.object,
    onChange: PropTypes.func.isRequired,
};

export default Media;



// WEBPACK FOOTER //
// ./src/util/Media.js